import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationUpdateProtectionContextModel extends OperationImportContextModel {
  learningEnd: Date;
}
